import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, map, of, shareReplay } from 'rxjs';
import { ApiService } from './core/services/api.service';
import { IUser } from '@common/models/IUser';

let users: IUser[] = null;

@Injectable({
  providedIn: 'root'
})
export class UserResolver  {
  constructor(private readonly apiService: ApiService){}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    if (users===null)  {
      return this.apiService.get(`User`)
      .pipe(
        map((res: IUser[]) =>  users = res),
        shareReplay(1),
      );
    }
  }
  getUserByEmail(email: any): Observable<IUser> {
    if (typeof email !== 'string') {
      return of(null as any);
    }

    const normalizedEmail = email.toLowerCase();

    const user = users.find(
      prop => prop.email?.toLowerCase() === normalizedEmail
    );

    if (user) {
      return of(user);
    }

    const userByAlternateEmail = users.find(
      prop =>
        prop.alternateEmail &&
        prop.alternateEmail.toLowerCase() === normalizedEmail
    );

    return of(userByAlternateEmail ?? null);
  }

}
